import type { IconProps } from './IconProps';

export const CodeIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.49607 1.26802C9.90042 1.35788 10.1554 1.75851 10.0655 2.16286L7.39885 14.1629C7.30899 14.5672 6.90836 14.8222 6.50401 14.7323C6.09966 14.6424 5.84471 14.2418 5.93457 13.8375L8.60123 1.83746C8.69109 1.43311 9.09172 1.17816 9.49607 1.26802ZM5.19704 4.1365C5.48993 4.42939 5.48993 4.90426 5.19704 5.19716L2.39403 8.00016L5.19704 10.8032C5.48993 11.0961 5.48993 11.5709 5.19704 11.8638C4.90414 12.1567 4.42927 12.1567 4.13638 11.8638L0.803044 8.53049C0.510151 8.2376 0.510151 7.76272 0.803044 7.46983L4.13638 4.1365C4.42927 3.8436 4.90414 3.8436 5.19704 4.1365ZM10.803 4.1365C11.0959 3.8436 11.5708 3.8436 11.8637 4.1365L15.197 7.46983C15.4899 7.76272 15.4899 8.2376 15.197 8.53049L11.8637 11.8638C11.5708 12.1567 11.0959 12.1567 10.803 11.8638C10.5101 11.5709 10.5101 11.0961 10.803 10.8032L13.606 8.00016L10.803 5.19716C10.5101 4.90426 10.5101 4.42939 10.803 4.1365Z"
      fill="currentColor"
    />
  </svg>
);
